import React, { useEffect } from 'react';
import { rules } from '@buzzfeed/consent';
import { isServer } from '../../utils/isServer';
import styles from './exCoPlayer.module.scss';

const EXCO_PLAYER_ID = '519954ad-6bd7-4e04-a38f-08f76bd50aff';
const EXCO_SCRIPT_SRC = `https://player.ex.co/player/${EXCO_PLAYER_ID}`;

export default function ExCoPlayer() {

  useEffect(() => {
    if (isServer()) {
      return;
    }

    let loadHandler = null;
    let scriptEl = null;

    rules.hasConsented('exco').then(hasConsent => {
      const initPlayer = () => {
        if (window.ExCoPlayer) {
          const playerApi = window.ExCoPlayer.connect(EXCO_PLAYER_ID);
          playerApi.init({
            showAds: hasConsent,
          });
        }
      };

      if (window.ExCoPlayer) {
        initPlayer();
        return;
      }

      scriptEl = document.querySelector(`script[src="${EXCO_SCRIPT_SRC}"]`);
      if (!scriptEl) {
        // Lives outside <head> so the next/head manager cannot remove it: the player
        // reads `programmatic` off this tag, and without it never exposes its API.
        scriptEl = document.createElement('script');
        scriptEl.className = 'exco-player';
        scriptEl.src = EXCO_SCRIPT_SRC;
        scriptEl.setAttribute('programmatic', 'true');
        document.body.appendChild(scriptEl);
      }

      loadHandler = initPlayer;
      scriptEl.addEventListener('load', loadHandler);
    }).catch(() => {
      // Consent check failed — player will load without programmatic init
    });

    return () => {
      if (scriptEl && loadHandler) {
        scriptEl.removeEventListener('load', loadHandler);
      }
    };
  }, []);

  return (
    <div className={styles.exCoPlayerWrapper}>
      <div id={EXCO_PLAYER_ID}></div>
    </div>
  );
}
